export class ClaimSearchFilter {
    PrescriptionNumber: string[] = [];
}
